var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KanBan',{attrs:{"list":_vm.list,"display-key":"Id","display-name":"Name"},on:{"on-sort":_vm.onSort}})}
var staticRenderFns = []

export { render, staticRenderFns }